import React from "react";

interface WrapCenterProps {
  children: React.ReactNode;
}

const WrapCenter: React.FC<WrapCenterProps> = ({ children }) => {
  return <div className="flex flex-col justify-center items-center h-full w-full">{children}</div>;
};

export default WrapCenter;
